import { useId, type ReactElement, type ReactNode } from 'react';

export interface FieldProps {
  label: string;
  hint?: string;
  /** Receives the generated id so the label stays associated with the control. */
  children: (id: string) => ReactElement;
}

/**
 * Label + control + optional hint. The control is a render prop so the caller
 * keeps full ownership of the input element and its props.
 */
export function Field({ label, hint, children }: FieldProps) {
  const id = useId();
  return (
    <div className="field">
      <label className="field__label" htmlFor={id}>
        {label}
      </label>
      {children(id)}
      {hint ? <span className="field__hint">{hint}</span> : null}
    </div>
  );
}

export interface FormErrorProps {
  children: ReactNode;
}

export function FormError({ children }: FormErrorProps) {
  if (!children) {
    return null;
  }
  return (
    <p className="alert alert--error" role="alert">
      {children}
    </p>
  );
}
